export function getOS() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/android/i.test(userAgent)) {
        return 'Android';
    } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return 'iOS';
    } else if (/windows phone/i.test(userAgent)) {
        return 'Windows Phone';
    } else if (/win/i.test(userAgent)) {
        return 'Windows';
    } else if (/mac/i.test(userAgent)) {
        return 'Mac';
    } else if (/linux/i.test(userAgent)) {
        return 'Linux';
    } else {
        return 'Unknown';
    }
}

export function getOSVersion() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/android/i.test(userAgent)) {
        return navigator.userAgent.match(/Android (\d+(\.\d+)?)/)[1];
    } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return navigator.userAgent.match(/OS (\d+_\d+)/)[1].replace('_', '.');
    } else if (/windows phone/i.test(userAgent)) {
        return navigator.userAgent.match(/Windows Phone (\d+(\.\d+)?)/)[1];
    } else if (/win/i.test(userAgent)) {
        return navigator.userAgent.match(/Windows NT (\d+(\.\d+)?)/)[1];
    } else if (/mac/i.test(userAgent)) {
        return navigator.userAgent.match(/Mac OS X (\d+_\d+)/)[1].replace('_', '.');
    } else if (/linux/i.test(userAgent)) {
        // You can add specific handling for Linux if needed
        return 'Unknown';
    } else {
        return 'Unknown';
    }
}

export function getDeviceModel() {
    // You may need to use additional libraries or methods to get detailed device information
    // This example is a simple demonstration and may not provide accurate device information for all cases
    return 'Unknown';
}

export function getDeviceBrand() {
    // You may need to use additional libraries or methods to get detailed device information
    // This example is a simple demonstration and may not provide accurate device information for all cases
    return 'Unknown';
}

export function getClientVersion() {
    // You may need to implement this based on your application's logic
    return 'web';
}

export function getBrowserName() {
    var userAgent = navigator.userAgent;
    
    if (userAgent.indexOf("Firefox") !== -1) {
        return "Mozilla Firefox";
    }
    else if (userAgent.indexOf("Edg") !== -1) {
        return "Microsoft Edge";
    } else if (userAgent.indexOf("Chrome") !== -1) {
        return "Google Chrome";
    } else if (userAgent.indexOf("Safari") !== -1) {
        return "Apple Safari";
    } else if (userAgent.indexOf("MSIE") !== -1 || userAgent.indexOf("Trident/") !== -1) {
        return "Internet Explorer";
    } else if (userAgent.indexOf("Opera") !== -1 || userAgent.indexOf("OPR") !== -1) {
        return "Opera";
    } else {
        return "Unknown";
    }
}